import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var DEFAULT_LANGUAGE = 'en';
var DEFAULT_REGION = 'US';
export var DEFAULT_LOCALE = "".concat(DEFAULT_LANGUAGE, "-").concat(DEFAULT_REGION);
var languageToLongLocaleCode = {
  cs: 'cs-CZ',
  da: 'da-DK',
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fi: 'fi-FI',
  fr: 'fr-FR',
  hu: 'hu-HU',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
  no: 'no-NO',
  nb: 'no-NO',
  nl: 'nl-NL',
  pl: 'pl-PL',
  ru: 'ru-RU',
  sv: 'sv-SE',
  th: 'th-TH',
  tr: 'tr-TR',
  uk: 'uk-UA',
  vi: 'vi-VN',
  zh: 'zh-CN'
};
export var normalizeLocale = function normalizeLocale(locale) {
  if (!locale) {
    return DEFAULT_LOCALE;
  }
  var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
  if (!match) {
    throw Error('Unable to get language and country from the supplied locale.');
  }
  var _match = _slicedToArray(match, 3),
    language = _match[1],
    region = _match[2];
  var normalizedLanguage = (language !== null && language !== void 0 ? language : '').toLowerCase();
  var normalizedRegion = (region !== null && region !== void 0 ? region : '').toUpperCase();
  if (normalizedLanguage && normalizedRegion) {
    return [normalizedLanguage, normalizedRegion].join('-');
  }
  var longLocaleCode = languageToLongLocaleCode[normalizedLanguage];
  return longLocaleCode !== null && longLocaleCode !== void 0 ? longLocaleCode : DEFAULT_LOCALE;
};